import { render, staticRenderFns } from "./Traceability.vue?vue&type=template&id=1adfaaf7&lang=pug&"
import script from "./Traceability.vue?vue&type=script&lang=ts&"
export * from "./Traceability.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports